import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  DefinitionList,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooksDateFormat } from '../../docs-routes'
import type { CSSProperties } from 'react'

const popupBodyStyle: CSSProperties = {
  marginBottom: '16px',
  marginTop: '5px'
}

const WebhookDateFormatDescription = () =>
  <div>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Date format
    </Header>
    <div style={popupBodyStyle}>
      <Paragraph>
        <Color variant='greyB'>
          Specify the string representation of a timestamp format to match your webhook integration. (Default: %d %b %Y, %H:%M:%S )
          <br />
          Please refer to the example timestamp format below.
        </Color>
      </Paragraph>
      <Paragraph>
        <DefinitionList variant='contrastOnKeyValue'>
          {
            {
              'Timestamp Format': 'Example',
              '%d %b %Y, %H:%M:%S (default)': '6 Dec 2024, 14:35:56'
            }
          }
        </DefinitionList>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooksDateFormat}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>

  </div>

export default WebhookDateFormatDescription
